/* eslint-disable */
/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react';
import ReactDOM from 'react-dom';
// import { StyleSheetManager } from 'styled-components';
import './index.css';

import { ConfigProvider } from 'antd';
import enUS from 'antd/lib/locale-provider/en_US';

import GA4React from 'ga-4-react';

// import './i18n';

import App from './App';
// import { BrowserRouter as Router } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
// declare const window: any;
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// let history;
function render(props: { container: any } = { container: null }) {
  const { container } = props;
  ReactDOM.render(
    <ConfigProvider locale={enUS}>
      <App />
    </ConfigProvider>,
    container
      ? container.querySelector('#root')
      : document.getElementById('root')
  );
}

const ga4react = new GA4React('G-0C3CWYT7QK', {
  send_page_view: false,
});
ga4react.initialize().catch((ex) => {
  console.log(ex);
});
render();
function loadGTMScript() {
  const gtmScript = document.createElement('script');
  gtmScript.src = '/gtm.js';
  // 可选：添加 async/defer 控制加载顺序
  gtmScript.async = true;
  // 将脚本插入到 <head> 或 <body> 中（确保执行）
  document.head.appendChild(gtmScript);

  // 可选：监听脚本加载成功/失败
  gtmScript.onload = () => {
    console.log('GTM 脚本加载成功');
  };
  gtmScript.onerror = (err) => {
    console.error('GTM 脚本加载失败：', err);
  };
}

// 页面加载完成后执行（或在需要的时机调用）
window.addEventListener('DOMContentLoaded', loadGTMScript);
// if (!window.__POWERED_BY_QIANKUN__) {
//   render();
// }

// export async function bootstrap() {}

// export async function mount(props: any) {
//   render(props);
// }

// export async function unmount(props: { container: any }) {
//   const { container } = props;
//   ReactDOM.unmountComponentAtNode(
//     container
//       ? container.querySelector('#root')
//       : document.getElementById('root')
//   );
// }
